import React from 'react'
import { Typography, Container, Link, Box } from '@mui/material'
import TelegramIcon from '@mui/icons-material/Telegram'

const Footer = () => {
  return (
    <footer>
      <Container
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <TelegramIcon className='icon' />
          <Typography variant='h6'>
            <Link
              color='inherit'
              href='https://t.me/sashalehedza'
              target='_blank'
              style={{
                textDecoration: 'none',
              }}
            >
              @sashalehedza
            </Link>
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <TelegramIcon className='icon' />
          <Typography variant='h6'>
            <Link
              color='inherit'
              href='https://t.me/storm_q_vods'
              target='_blank'
              style={{
                textDecoration: 'none',
              }}
            >
              @storm_q_vods
            </Link>
          </Typography>
        </Box>
      </Container>
    </footer>
  )
}

export default Footer
